/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-fake-tabs',
  templateUrl: './cd-fake-tabs.component.html',
  styleUrls: ['./cd-fake-tabs.component.scss'],
  imports: [NgClass],
})
export class CdFakeTabsComponent implements OnInit {
  @Input() options: string[] = [];
  @Input() selectedIndex = 0;
  @Output() selectedIndexChange = new EventEmitter<number>();
  @Input() optionsObj: { label: string; value: any }[] = [];
  @Input() selectedValue?: any;
  @Output() selectedValueChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  onChange(index: number) {
    this.selectedIndex = index;
    this.selectedIndexChange.emit(this.selectedIndex);
  }

  onChangeObjValue(value: any) {
    this.selectedValue = value;
    this.selectedValueChange.emit(this.selectedValue);
  }
}
